<script setup>
import BaseInputFloatingLabelValidated from "@/components/forms/BaseInputFloatingLabelNumber.vue";
import {useMatchedBetStore} from "@/stores/MatchedBetStore";
import {storeToRefs} from "pinia";
import {computed} from "vue";

const matchedBetStore = useMatchedBetStore();
const {layBetData, oddsmatcherData} = storeToRefs(matchedBetStore);

const layStake = computed(() => {
  return matchedBetStore.getLayStake(matchedBetStore.backBetData, matchedBetStore.layBetData)
})
</script>

<template>
  <div class="bet-card">
    <div class="bet-card-head">
      <h6 class="heading-small">Lay Bet: <span v-if="oddsmatcherData.exchangeDisplayName">{{ oddsmatcherData.exchangeDisplayName}}</span></h6>
    </div>
    <div class="bet-card-body">
      <BaseInputFloatingLabelValidated
          :config="{ label: 'Odds (decimal)', name: 'odds', hasClearButton: false, classes: { error: 'has-error' } }"
          v-model="layBetData.odds"/>
      <BaseInputFloatingLabelValidated
          :config="{ label: 'Commission (%)', name: 'lay-commission', hasClearButton: false, classes: { error: 'has-error' } }"
          v-model="layBetData.commission"/>
    </div>
    <div class="bet-card-footer p-large">
      <div>Lay Stake: £{{ Number(layStake).toFixed(2) }}</div>
      <div>Liability: £{{ Number(matchedBetStore.getLiability(layStake, layBetData.odds)).toFixed(2) }}</div>
    </div>
  </div>
</template>


<style scoped>
.bet-card {
  background-color: var(--clr-primary-20);
  color: var(--clr-black-100);
}

.bet-card-head {
  background-color: var(--clr-primary-20);
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center; /* Ensure vertical alignment */
  justify-content: left;
  padding: 1rem;
  border-bottom: 2px solid var(--clr-accent-20);
  height: 68px;
}

.heading-small {
  margin: 0; /* Remove default margin */
  text-align: center; /* Center text within heading */
  padding: 0;
}


.bet-card-body {
  margin: 1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 5%;
}

.bet-card-body > * {
  flex: 1 1 47.5%; /* Allow elements to grow and shrink, and set their base width to approximately 45% */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

.bet-card-footer {
  padding: 1rem;
  background-color: var(--clr-primary-75);
  display: flex;
  justify-content: center;
  gap: 3rem;
  font-weight: var(--fw-semi-bold);
  color: white;

}
</style>